const calcFreeshipping = ($elem, totalPrice) => {
  if ($elem.length) {
    const $elemInner = $elem.find('.js-elem-inner')
    const $targetPriceElem = $elem.find('.js-elem-inner[data-js-target-price]')
    let freeShippingFlag = false
    const elemClass = 'is-alt'

    if ($targetPriceElem.length && $targetPriceElem.find('span').length) {
      const targetPrice = parseInt($targetPriceElem.attr('data-js-target-price'))
      if (targetPrice >= totalPrice) {
        const differencePrice = targetPrice - totalPrice
        $targetPriceElem.find('span').text(Shopify.formatMoney(differencePrice))
      } else {
        freeShippingFlag = true
      }
    }

    if ($elemInner.length) {
      if (freeShippingFlag) {
        $elemInner.addClass(elemClass)
      } else {
        $elemInner.removeClass(elemClass)
      }
    }
  }
}

export const ajaxCart = (widget, showWidget = true) => {
  $.ajax({
    url: '/cart',
    success: function (data) {
      const $totalElem = $(data).find('.js-cart-global-total')
      const totalPrice = parseInt($totalElem.attr('data-js-cart-total-price'))
      const $total = $totalElem.html()
      $('.js-btn-cart strong').html($total)
      const $html = $(data).find('.js-cart-container').html()
      const $htmlSection = $(data).find('.js-cart-section-container').html()
      const $widgetCartContainer = $('.js-widget-cart .js-cart-container')

      calcFreeshipping($('.js-header-bar'), totalPrice)
      calcFreeshipping($('.js-cart-calc-item'), totalPrice)

      if (widget) {
        if ($widgetCartContainer.length) {
          $widgetCartContainer.html($html)

          if (showWidget) {
            $('.js-widget-cart').addClass('is-expanded')
          }
        }
      } else {
        if ($('.js-cart-section-container').length) {
          $('.js-cart-section-container').html($htmlSection)
        }
      }
    }
  })
}
